<script type="text/ecmascript-6">
    import Question from "./mixin/Question.vue";

    export default {
        mixins: [
            Question,
        ],
        props: {
            maintitle: {
              default() {
                return 'Door Drip Colour';
              }
            },
            title: {
                default(){
                    return 'Door Drip Colour';
                }
            },
            component_id: {
                default(){
                    return 'door_drip_colour';
                }
            },
            externalColour: {
                required: true
            },
            frameProfile: {
                required: true
            },
            doorRange: {
                required: false,
                default() {
                    return 0;
                }
            },
        },
        computed: {
            passed_filter(){
                return this.variable_ready(this.externalColour, this.frameProfile, this.doorRange);
            },
            url(){
                return '/api/options/' + this.fabricator + '/door-drip-colour?external_colour=' + this.externalColour + '&profile=' + this.frameProfile + '&door_range=' + this.doorRange;
            },
            cache_key(){
                return '_' + this.externalColour + '_' + this.frameProfile + '_' + this.doorRange;
            },
            panel_required(){
                return true;
            }
        },
        watch: {
            'frameProfile': function (val, oldVal) {
                this.update_options();
            },
            'externalColour': function (val, oldVal) {
                this.update_options();
            },
            'doorRange': function (val, oldVal) {
                this.update_options();
            },
        }
    }
</script>
